import { useState } from "react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Mail, CheckCircle, Loader2 } from "lucide-react";
import { toast } from "sonner";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const Newsletter = ({ compact = false }) => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [subscribed, setSubscribed] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email.trim()) return;

    setLoading(true);
    try {
      const res = await axios.post(`${API}/newsletter/subscribe`, { email });
      setSubscribed(true);
      setEmail("");
      toast.success(res.data.message);
    } catch (e) {
      toast.error("Bir hata oluştu. Lütfen tekrar deneyin.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <section
      className="max-w-screen-2xl mx-auto px-4 md:px-8 lg:px-12 py-16 md:py-24"
      data-testid="newsletter-section"
    >
      <div className={compact ? "" : "max-w-2xl mx-auto text-center"}>
        {!compact && (
          <span className="font-mono text-xs uppercase tracking-widest text-[#1B4F72] mb-3 block">
            Bülten
          </span>
        )}
        <h2 className={compact
          ? "text-base font-semibold tracking-tight mb-2"
          : "text-3xl md:text-4xl font-semibold tracking-tight leading-tight mb-4"
        } style={{ fontFamily: "'Playfair Display', serif" }}>
          {compact ? "Bültene Abone Olun" : "Sektördeki Gelişmeleri Kaçırmayın"}
        </h2>
        {!compact && (
          <p className="text-base text-stone-500 mb-8 max-w-lg mx-auto">
            Haftalık bültenimize abone olun. Fuar sektöründeki en son haberler,
            trendler ve analizler doğrudan e-posta kutunuza gelsin.
          </p>
        )}
        {compact && (
          <p className="text-xs text-stone-500 mb-3">Haftalık sektör bülteni doğrudan e-postanıza.</p>
        )}

        {subscribed ? (
          <div className="flex items-center justify-center gap-2 text-green-700 bg-green-50 border border-green-200 py-4 px-6" data-testid="newsletter-success">
            <CheckCircle className="w-5 h-5" />
            <span className="font-medium">Bültene başarıyla abone oldunuz!</span>
          </div>
        ) : (
          <form
            onSubmit={handleSubmit}
            className={compact ? "flex flex-col gap-2" : "flex flex-col sm:flex-row gap-3 max-w-md mx-auto"}
            data-testid="newsletter-form"
          >
            <div className="relative flex-1">
              <Mail className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-stone-400" />
              <Input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="E-posta adresiniz"
                required
                className="pl-10 rounded-none border-stone-300 h-12"
                data-testid="newsletter-email-input"
              />
            </div>
            <Button
              type="submit"
              disabled={loading}
              className="rounded-none h-12 px-8 bg-stone-900 text-white hover:bg-[#1B4F72] transition-colors font-mono text-xs uppercase tracking-widest"
              data-testid="newsletter-submit"
            >
              {loading ? (
                <Loader2 className="w-4 h-4 animate-spin" />
              ) : (
                "Abone Ol"
              )}
            </Button>
          </form>
        )}
      </div>
    </section>
  );
};
